/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NgnFilterPipe as ɵa} from './lib/ngn-filter.pipe';